import useMediaQuery from './useMediaQuery';

export type { Query } from './useMediaQuery';
export default useMediaQuery;
